/* Кнопка «ⓘ» и её поповер. Тот же приём привязки, что у кнопки аккаунта
   (AccountButton.module.css / AccountMenu.module.css): якорь-обёртка с
   position: relative, сам поповер — absolute под кнопкой. */
.box {
  position: relative;
  display: inline-flex;
  flex: none;
}

/* Круглая маленькая кнопка, а не btn-sm: рядом с датой она должна читаться
   как пиктограмма-подсказка, а не как ещё одно действие в общем ряду. */
.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: var(--text-3);
  cursor: pointer;
}

.trigger:hover {
  background: var(--surface-2);
  color: var(--text-2);
}

.trigger:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.panel {
  position: absolute;
  top: calc(100% + var(--sp-2));
  left: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  width: 260px;
  padding: var(--sp-4);
  background: var(--surface-raised);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-rim), var(--shadow-lift);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.panel p {
  margin: 0;
}

.heading {
  margin: 0;
  color: var(--text);
  font-size: var(--fs-sm);
  font-weight: 600;
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Тач-зона кнопки растёт до 44px, а сам поповер — та же нижняя шторка, что
   и у попапа кнопки аккаунта: absolute под пальцем на узком экране легко
   обрезается краем плитки или экрана. */
@media (max-width: 720px) {
  .trigger {
    width: 44px;
    height: 44px;
  }

  .panel {
    position: fixed;
    inset: auto var(--sp-4) var(--sp-4) var(--sp-4);
    z-index: 1100;
    width: auto;
    max-height: 70vh;
    overflow-y: auto;
  }
}
